import { render } from "./PerComparison.vue?vue&type=template&id=9d8cdf0a&scoped=true"
import script from "./PerComparison.vue?vue&type=script&lang=js"
export * from "./PerComparison.vue?vue&type=script&lang=js"

import "./tailwind.css?vue&type=style&index=0&id=9d8cdf0a&scoped=true&lang=css&external"
import "./PerComparison.vue?vue&type=style&index=1&id=9d8cdf0a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d8cdf0a"]])

export default __exports__